export default __webpack_public_path__ + "static/media/zbp_folio_creation_icon.cb1ddacd.svg";